import styles from "./CommonFields.module.css";
import { Field } from "@shopify/react-form";
import TagsField from "../../../components/TagsField";
import { Label } from "@shopify/polaris";

const HideNativeElement = ({
    hide_native_elements,
    bundleType,
    dispatchBundleConfig,
}: {
    hide_native_elements: Field<string>;
    dispatchBundleConfig: any;
    submit: (event?: React.FormEvent) => Promise<void>;
    bundleType: string;
}) => {
    return (
        <div className={`${styles.formRow} ${styles.row2}`}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: "100%",
                }}
            >
                <Label id={"hide_native_elements"}>Hide shopify elements</Label>
                <TagsField
                    label={"Customers tag"}
                    bundleType={bundleType}
                    section={"Display bar to"}
                    labelHidden
                    placeholder={"Add selectors"}
                    value={hide_native_elements?.value}
                    onChange={(value) => {
                        hide_native_elements.onChange(value);
                        dispatchBundleConfig({
                            payload: value,
                            key: "hide_native_elements",
                        });
                    }}
                    autoComplete="off"
                />
            </div>
        </div>
    );
};

export default HideNativeElement;
